export default __webpack_public_path__ + "static/media/graf-mission.6e229837.svg";